export enum CreateNewFolderError {
    None,
    ConflictFolderName,
    Generic,
}
